import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { analytics } from "@heycatch/sdk";
import "@/index.css";
import App from "@/App";

analytics.init({
  projectKey: "hck_pk_5Rdwh7CCY4LGGtXU-Nj80sB0vvQU9WRn",
  install: {
    framework: "react",
    frameworkVersion: "19",
    agent: "other",
  },
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const rootEl = document.getElementById("root");
const appTree = (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);
// If react-snap prerendered this route at build time, the shell already
// contains hydratable HTML (crawlable breadcrumbs, related links, canonical,
// JSON-LD). Call hydrateRoot so React attaches to the existing DOM instead
// of blowing it away — otherwise we'd lose the SEO payload before Googlebot
// sees it. Live routes without a prerender fall back to the normal
// createRoot path.
if (rootEl.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootEl, appTree);
} else {
  const root = ReactDOM.createRoot(rootEl);
  root.render(appTree);
}
